var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/PositionLabels/index.js";
import React from 'react';
import pt from 'prop-types';
import { times } from 'ramda';
import { fretWidth } from './../../../lib/fretboard';
import Label from './Label';
import Wrapper from './Wrapper';
import FretLabels from './FretLabels';
// const labels = ['open', 'I', '', 'III', '', 'V', '', 'VII', '', '', 'X', '', 'XII'];

const labels = ['', '●', '', '●', '', '●', '', '●', '', '', '●', '', '●●'];

const fretLabels = nrOfFrets => n => /*#__PURE__*/React.createElement(Label, {
  key: `label-${n}`,
  width: fretWidth(nrOfFrets)(n),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 13,
    columnNumber: 3
  }
}, labels[n + 1]);

const PositionLabels = ({
  openWidth,
  nutWidth,
  nrOfFrets
}) => /*#__PURE__*/React.createElement(Wrapper, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 21,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(Label, {
  width: openWidth,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 22,
    columnNumber: 5
  }
}, labels[0]), /*#__PURE__*/React.createElement(Label, {
  width: nutWidth,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 23,
    columnNumber: 5
  }
}, "\xA0"), /*#__PURE__*/React.createElement(FretLabels, {
  width: 100 - openWidth - nutWidth,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 24,
    columnNumber: 5
  }
}, times(fretLabels(nrOfFrets), nrOfFrets)));

PositionLabels.propTypes = {
  nutWidth: pt.number.isRequired,
  openWidth: pt.number.isRequired,
  nrOfFrets: pt.number.isRequired
};
export default PositionLabels;
